<!--
 * @Author: jianfanfan 1217572833@qq.com
 * @Date: 2023-02-22 18:58:34
 * @LastEditors: jianfanfan 1217572833@qq.com
 * @LastEditTime: 2024-09-02 09:40:11
 * @FilePath: \buypos-pc\src\components\software.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<style>
.point_down {
  width: 100% !important;
  top: 0px;
  position: fixed;
  z-index: 9999;
}
</style>
<template>
  <div>
    <headerNav></headerNav>
    <img
      src="./../assets/images/point_down.png"
      v-show="showImg"
      class="point_down"
      @click="imgBtn"
    />
    <div class="center_box">
      <img
        src="https://dudian-buypos-cn.oss-cn-shenzhen.aliyuncs.com/resource/images/pc-banner.jpg"
        alt
        @click="goMall"
      />
    </div>
    <div class="download_box m_tran50">
      <div class="m_clearLR download_div">
        <div class="m_floatL download_img">
          <img src="./../assets/images/android.png" />
        </div>
        <div class="m_floatL download_text">
          <div>【Dlabel云标签】编辑软件，安卓手机端下载</div>
          <div>161MB</div>
          <div>用于蓝牙版标签打印</div>
        </div>
        <div
          class="m_floatR download_down"
          @click="downPC('dlabel_chiteng_ad')"
        >
          <a>下载</a>
          <div id="qrcode" class="m_floatL" ref="qrcode"></div>
        </div>
      </div>
      <div class="m_clearLR download_div">
        <div class="m_floatL download_img">
          <img src="./../assets/images/iphone.png" />
        </div>
        <div class="m_floatL download_text">
          <div>【Dlabel云标签】编辑软件，苹果手机端下载</div>
          <div>164MB</div>
          <div>蓝牙版标签打印,需ios10.3以上系统</div>
        </div>
        <div
          class="m_floatR download_down"
          @click="toDown('https://itunes.apple.com/cn/app/id1397719437?mt=8')"
        >
          <a>下载</a>
          <div id="qrcodeIos" class="m_floatL" ref="qrcodeIos"></div>
        </div>
      </div>

      <div class="m_clearLR download_div">
        <div class="m_floatL download_img">
          <img src="./../assets/images/pc.png" />
        </div>
        <div class="m_floatL download_text">
          <div>【Dlabel云标签】编辑软件，电脑端下载</div>
          <div>120.9MB</div>
          <div>电脑端下载网址:https://dlabel.cn/ct</div>
        </div>
        <div
          class="m_floatR download_down"
          @click="downPC('dlabel_chiteng_pc_64')"
        >
          <a>下载</a>
        </div>
      </div>
    </div>
    <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '400px', height: '200px' }"
      @success="login"
    />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import header from "./header";
import Verify from "./verifition/Verify";
import axios from "axios";
import qs from "qs";
import { v4 as uuidv4 } from "uuid";
import { md5Encrypt } from "./verifition/utils/ase";
export default {
  components: {
    headerNav: header,
    Verify
  },
  data() {
    return {
      apk:
        "https://fileadapp.ctaiot.com/dlabel_version/pc/website/Dlabel%E4%BA%91%E6%A0%87%E7%AD%BE.apk",
      showImg: false,
      ios: "https://itunes.apple.com/cn/app/id1397719437?mt=8",
      date: "",
      appUrl: "https://dlabel.cn/ct",
      pcUrl: "",
      rand: "", //js生成的 uuid
      auth_type: "dlabel_chiteng_pc_64", //下载64位时：dlabel_pc_64  下载32位时：dlabel_pc_32 下载AD时：dlabel_ad
      textArr: [
        {
          // title:'Dlabel安卓端下载',
          // url:'http://39.108.49.16/media/app/app/Dlabel_112_1.apk',
          // size:'6.5MB'
        }
      ]
    };
  },
  created() {
    this.rand = uuidv4().replace(/-/g, ""); //js生成的 uuid
    this.$nextTick(() => {
      this.qrcode();
    });
  },
  methods: {
    toDown(url) {
      location.href = url;
    },
    /**
     * 下载app 防爆处理
     * @param {*} data  下载64位时：dlabel_pc_64  下载32位时：dlabel_pc_32 下载AD时：dlabel_ad
     */
    async downloadAPP() {
      axios({
        method: "post", //请求方法
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: "https://captchaapi.ctaiot.com/api/app/auth_time"
      }).then(response => {
        const auth_key = `${response.data.data}-${this.rand}-0-${md5Encrypt(
          response.data.data,
          this.rand
        )}`;
        // console.log("auth_key", this.rand);
        axios({
          method: "post", //请求方法
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          url: `https://captchaapi.ctaiot.com/api/app/auth_1?auth_key=${auth_key}&auth_type=${this.auth_type}`
        }).then(res => {
          if (res.data.code === 100) {
            location.href = res.data.data;
          }
        });
      });
    },
    // 下载PC
    downPC(type) {
      //   this.pcUrl = url;
      this.auth_type = type;
      axios({
        method: "get", //请求方法
        url: "https://captchaapi.ctaiot.com/api/download_limit/get"
      })
        .then(res => {
          if (res.data.data === 0) {
            // location.href = url;
            this.downloadAPP();
          } else {
            this.$refs.verify.show();
          }
        })
        .catch(err => {
          location.href = url;
        });
    },
    login() {
      //   location.href = this.pcUrl;
      this.downloadAPP();
    },
    goMall() {
      axios({
        method: "post", //请求方法
        data: qs.stringify({
          equip: 4,
          type: 6
        }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: "https://bsbapi.ctaiot.com/api/data/down/time.json"
      }).then(res => {
        window.open(
          "https://shop128878083.youzan.com/v2/showcase/homepage?alias=wwV2bLjoYi"
        );
      });
    },
    qrcode() {
      let qrcode = new QRCode("qrcode", {
        width: 150, // 设置宽度，单位像素
        height: 150, // 设置高度，单位像素
        text: this.appUrl // 设置二维码内容或跳转地址
      });
      let qrcodeIos = new QRCode("qrcodeIos", {
        width: 150, // 设置宽度，单位像素
        height: 150, // 设置高度，单位像素
        text: this.appUrl // 设置二维码内容或跳转地址
      });
    },
    imgBtn() {
      this.showImg = !this.showImg;
    },
    isWeiXin() {
      // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase();
      // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    btnApk() {
      var u = navigator.userAgent;
      var app = navigator.appVersion;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      if (isAndroid) {
        // 这个是安卓操作系统
        if (this.isWeiXin()) {
          this.showImg = true;
        } else {
          location.href = this.apk;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/software.vue